export const sv = {
    'nav.today': "Översikt Idag",
    'nav.calendar': "Efterfrågekalender",
    'nav.rates': "Priser & Regler",
    'nav.automation': "Automatisering",
    'nav.audit': "Revisionslogg",
    'nav.settings': "Inställningar",
    'sidebar.status': "Ansluten",
    'stat.occupancy': "Beläggning",
    'stat.adr': "Snittpris (ADR)",
    'stat.revpar': "RevPAR",
    'stat.revenue': "Est. Intäkt",
    'stat.trend.vsLastWeek': "vs Förra Veckan",
    'stat.trend.onPace': "Enligt plan",
    'dashboard.actions.title': "Rekommenderade Åtgärder",
    'dashboard.actions.empty': "Inga åtgärder hittades.",
    'filter.all': "Alla",
    'filter.pricing': "Prissättning",
    'filter.restriction': "Restriktioner",
    'action.approve': "Godkänn",
    'action.reject': "Avvisa",
    'action.risk.low': "låg risk",
    'action.risk.medium': "medel risk",
    'action.risk.high': "hög risk",
    'action.label.current': "Nuvarande",
    'action.label.proposed': "Föreslaget",
    'action.metric.impact': "Påverkan",
    'action.metric.why': "Varför",
    'action.status.executed': "Auto-Utförd",
    'header.search': "Sök...",
    'header.logout': "Logga ut",
    'auto.level.title': "Autopilotnivå",
    'auto.level.manual': "Manuell",
    'auto.level.manual.desc': "Du godkänner varje rekommendation.",
    'auto.level.assisted': "Assisterad",
    'auto.level.assisted.desc': "Auto-godkänn låg risk. Granska stora ändringar.",
    'auto.level.auto': "Helautomatisk",
    'auto.level.auto.desc': "AI hanterar priser 24/7 inom dina gränser.",
    'auto.level.active': "Aktiv",
    'auto.guardrails.title': "Säkerhetsgränser",
    'auto.guardrails.maxIncrease': "Max Daglig Ökning",
    'auto.guardrails.maxIncrease.desc': "Undvik prischocker.",
    'auto.guardrails.maxDecrease': "Max Daglig Minskning",
    'auto.guardrails.maxDecrease.desc': "Undvik prisdumpning.",
    'auto.guardrails.minRate': "Lägsta Pris",
    'auto.guardrails.minRate.desc': "Sälj aldrig under detta pris (Netto).",
    'auto.emergency.title': "Nödkontroll",
    'auto.emergency.label': "Nödstopp",
    'auto.emergency.desc': "Pausa all automatisering omedelbart.",
    'auto.emergency.btn': "PAUSA SYSTEM",
    'rates.filter.all': "Alla Rumstyper",
    'rates.filter.next14': "Kommande 14 Dagar",
    'rates.export': "Exportera",
    'audit.table.time': "Tid",
    'audit.table.actor': "Användare",
    'audit.table.category': "Kategori",
    'audit.table.action': "Åtgärd",
    'audit.table.details': "Detaljer",
    'audit.table.status': "Status",
    'settings.pms.title': "PMS-anslutning",
    'settings.pms.connected': "Ansluten till",
    'settings.pms.disconnect': "Koppla från",
    'settings.account.title': "Konto",
    'settings.account.role': "Roll",
    'settings.restart': "Starta om Onboarding",
    'onboard.title': "Anslut PMS",
    'onboard.desc': "Välj ditt PMS för att synkronisera.",
    'onboard.connecting': "Ansluter...",
    'onboard.connect': "Anslut",
    'onboard.success.title': "Inställning Klar!",
    'onboard.success.desc': "**SynthHotel Berlin** är nu synkroniserat.",
    'onboard.success.sub': "Importerade 3 rumstyper, 14 prisplaner och 243 bokningar.",
    'onboard.btn.dashboard': "Gå till Dashboard",
    'action.dynamic.weekend.title': "Höj Pris för Helg",
    'action.dynamic.weekend.desc': "Beläggning > 75% Lördag, stark efterfrågan (+12 rum på 24h).",
    'action.dynamic.minstay.title': "Aktivera Min. Vistelse 2 Nätter",
    'action.dynamic.minstay.desc': "Taylor Swift konsert. Förhindra 1-nattsbokningar.",
    'action.dynamic.distress.title': "Sänk Pris (Låg Efterfrågan)",
    'action.dynamic.distress.desc': "Beläggning 35% nästa Tisdag. Konkurrenter sänkte 10€.",
    'action.dynamic.gap.title': "Fyll Lucka: Ta bort CTA",
    'action.dynamic.gap.desc': "Enkel näts lucka. Ta bort 'Stängt för Ankomst' för att sälja.",
};
